/**
 * Modals Index
 * 
 * Re-exports all modal components for backwards compatibility.
 * The original Modals.js combined all three - this splits them up.
 */

import React from 'react';
import MenuDropdown from './MenuDropdown';
import ImportModal from './ImportModal';
import EditTaskModal from './EditTaskModal';

// Default export for backwards compatibility with existing imports
export default function Modals(props) {
  const {
    // Menu dropdown state
    showMenu,
    setShowMenu,
    onExport,
    onOpenImport,
    
    // Import modal state
    showImportModal,
    setShowImportModal,
    importText,
    setImportText,
    onImport,
    
    // Edit modal state
    editingTask,
    setEditingTask,
    tasks,
    contextOptions,
    onUpdateTask,
    onCloseEdit
  } = props;

  return (
    <>
      <MenuDropdown
        showMenu={showMenu}
        setShowMenu={setShowMenu}
        onExport={onExport}
        onOpenImport={onOpenImport}
      />
      <ImportModal
        showImportModal={showImportModal}
        setShowImportModal={setShowImportModal}
        importText={importText}
        setImportText={setImportText}
        onImport={onImport}
      />
      <EditTaskModal
        editingTask={editingTask}
        setEditingTask={setEditingTask}
        tasks={tasks}
        contextOptions={contextOptions}
        onUpdateTask={onUpdateTask}
        onCloseEdit={onCloseEdit}
      />
    </>
  );
}

// Named exports for direct imports
export { MenuDropdown, ImportModal, EditTaskModal };
